import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// ✅ Firebase Config
const firebaseConfig = {
  apiKey: "AIzaSyBCx19_GN95d7VAywmnQKgMI96N2udZM_4",
  authDomain: "calendar-a52de.firebaseapp.com",
  projectId: "calendar-a52de",
  storageBucket: "calendar-a52de.appspot.com", // ✅ DÜZELTİLDİ
  messagingSenderId: "879792858115",
  appId: "1:879792858115:web:e94823e77b2bbd66359a36",
};



// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
